import { EmptyCell } from './EmptyCell';

export default EmptyCell;
